import apiFetch from '../fetch';

export const fetchUserStats = async (userId) => {
  const url = `/api/users/${userId}/stats`;

  const response = await apiFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response;
};
